let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iNh3z")).then(() => parcelRequire('2oqB3'));